export const usePageHeaderLinksAdditionalItems = (): {
  top?: PageLinkItem[]
  bottom?: PageLinkItem[]
} => {
  const session = useSessionStore()

  const isInAHOrganisation = computed(() =>
    session.session?.user.organisations?.some(
      (organisation) => organisation.idOrganisationType === "BEREICH_AH"
    )
  )
  return {
    top: [
      {
        id: "iff-fees",
        url: "/fees",
        textLocaleKey: "iff.components.fee.headline",
        icon: "i-ic-outline-arrow-forward",
        order: 400,
        condition: () => Boolean(isInAHOrganisation.value),
      },
      {
        id: "warning-file",
        url: "/data-browser/warning-file",
        textLocaleKey: "custom.pages.data-browser-warning-file.title",
        order: 600,
        condition: () => hasOrganisationRole("BLOCKED_APPLICANT_ADMIN"),
      },
      {
        id: "reference-professions",
        url: "/data-browser/reference-professions",
        textLocaleKey: "custom.pages.data-browser-reference-professions.title",
        order: 700,
      },
      {
        id: "exam-signups",
        url: "/exam-signups",
        textLocaleKey: "custom.pages.exam-signups.title",
        order: 900,
        condition: () => hasOrganisationRole("EXAMINATION_ADMIN"),
      },
      {
        id: "bqfg",
        url: "/bqfg",
        textLocaleKey: "custom.pages.bqfg.title",
        order: 1000,
        condition: () => hasOrganisationRole("STATISTIC_ADMIN"),
      },
    ],
  }
}
